export default __webpack_public_path__ + "static/fabric-style-1-5df2261e0e4a02cd4f10e96941060440.png";